"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadingIndicator = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = require("b2b-components/theme/components/Icon");
var _classnames = _interopRequireDefault(require("classnames"));
require("./LoadingIndicator.scss");
const LoadingIndicator = _ref => {
  let {
    className
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    className: (0, _classnames.default)('cds-SearchableSelect-LoadingIndicator', className),
    name: _Icon.ICON_NAME.loader,
    size: _Icon.ICON_SIZE.small
  });
};
exports.LoadingIndicator = LoadingIndicator;
//# sourceMappingURL=LoadingIndicator.js.map